module.exports = __webpack_public_path__ + "static/media/数字冰雹安防系统.9b64fa6.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/viedeo/数字冰雹安防系统.mp4
// module id = jYMV
// module chunks = 1